import { Component, ojs, app, payload } from "modular-openscriptjs";
import { empty, cleanDispose, eParse, either } from "../../helpers";
import { dom, tool } from "../../fotastart";
import {
    _UNIQUE_ID_,
    ACTION_CALLBACKS,
    ACTION_NAME_CALLBACKS,
} from "../../declarations";
import MainActionCanvas from "../Offcanvas/MainActionCanvas";
import SolidIcon from "../Blocks/SolidIcon";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

ojs(MainActionCanvas, SolidIcon);

export default class MainActionForm extends Component {
    holder = null;
    currentCallbackId = null;
    currentNameCallbackId = null;

    renderForm(name, callbackId, nameCallbackId, ...args) {
        if (empty(callbackId)) {
            callbackId = _UNIQUE_ID_;
        }

        return h.$(
            h.div(
                {
                    maf_hook: `${callbackId}`,
                    maf_name_hook: nameCallbackId,
                },
                h.button(
                    {
                        class: "btn btn-lg btn-dark rounded-pill w-100 px-4 py-3",
                        onclick: this.method("runCallback", [callbackId]),
                    },
                    h.span(name),
                ),
                ...args,
            ),
        );
    }

    runCallback(callbackId) {
        if (!(callbackId in ACTION_CALLBACKS)) return;
        return ACTION_CALLBACKS[callbackId](this, callbackId);
    }

    clearCallback(callbackId = null, nameCallbackId = null) {
        if (callbackId) {
            delete ACTION_CALLBACKS[callbackId];
        }

        if (nameCallbackId) {
            delete ACTION_NAME_CALLBACKS[nameCallbackId];
        }
    }

    async showForm(ed, event) {
        if (this.holder) {
            this.clearCallback(
                this.currentCallbackId,
                this.currentNameCallbackId,
            );
            cleanDispose(this.holder);
        }

        /**
         * @type {MainActionData} data
         */
        const data = eParse(ed).message.get("data", {});
        let nameCallbackId = data.nameCallbackId;

        this.currentCallbackId = data.callbackId;
        this.currentNameCallbackId = nameCallbackId;

        this.holder = tool.offcanvas(
            h.MainActionCanvas(
                this.renderForm(
                    ACTION_NAME_CALLBACKS[nameCallbackId](this, nameCallbackId),
                    data.callbackId,
                    nameCallbackId,
                    data.attributes,
                ),
            ),
            either(
                data.closeable,
                h.span(
                    {
                        class: "text-secondary d-block text-center",
                        onclick: this.method("closeForm", [
                            data.callbackId,
                            nameCallbackId,
                        ]),
                    },
                    h.SolidIcon("chevron-down"),
                ),
                null,
            ),
            "bottom",
            {
                data_bs_backdrop: false,
                data_bs_scroll: true,
                style: "min-height: auto; max-height: fit-content; max-width: 500px; margin-left: auto; margin-right: auto; z-index:1080;",
                class: "shadow-lg",
            },
        );

		setTimeout(() => {
			this.holder?.show();
		}, 200);
    }

    closeForm(callbackId = null, nameCallbackId = null) {
        this.holder?.hide();
        this.clearCallback(callbackId, nameCallbackId);
    }

    $$app = {
        needs: {
            mainActionPrompt: (ed, event) => this.showForm(ed, event),
            to: {
                closeMainActionPrompt: (ed, event) =>
                    this.closeForm(
                        this.currentCallbackId,
                        this.currentNameCallbackId,
                    ),
            },
        },
    };

    $$ojs = {
        routeChanged: (ed, event) =>
            this.closeForm(),
    };
}
